import { Component, OnInit } from '@angular/core';
import { ValidationService } from '../services/validation.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { PasswordValidator } from '../models/PasswordValidator';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-confirm-reset',
  templateUrl: './confirm-reset.component.html',
  styleUrls: ['./confirm-reset.component.scss']
})

export class ConfirmResetComponent implements OnInit {
  passwordForm: FormGroup;
  passwordValid = false;
  passwordValidator = new PasswordValidator();

  constructor(
    private router: Router,
    private authService: AuthService,
    private validationService: ValidationService,
    private formBuilder: FormBuilder,
    private userService: UserService
  ) {
    this.passwordForm = this.formBuilder.group({
        password: ['', [Validators.required]],
        confirmpassword: [{value: '', disabled: true}, [Validators.required]]
      }, {validator: this.validationService.matchingPasswords('password', 'confirmpassword')}
    );
  }

  ngOnInit() {
    this.passwordForm.controls.password.valueChanges.subscribe(value => this.passwordRequirementsValidator(value));
  }

  passwordRequirementsValidator(value: string) {
    if (!value) {
      this.passwordValidator.reset();
    } else {
      this.authService.validatePassword(value).subscribe(passwordValidations => {
        passwordValidations.noSpaces = !value.includes(' ');
        this.passwordValidator.setAllValidations(passwordValidations);
        this.passwordValidator.checkAllValidations() ?
          this.passwordForm.controls.confirmpassword.enable() :
          this.passwordForm.controls.confirmpassword.disable();
      },
      error => {
        if (error.status === 401) {
          this.router.navigate(['/login']);
        }
      });
    }
  }

  submitReset() {
    const password = this.passwordForm.controls.password.value;
    this.authService.sendReset(password, this.userService.localUserId).subscribe(
      () => {
        console.log('CLEARING LOCAL STORAGE - 4');
        localStorage.clear();
        this.router.navigate(['/login']);
      },
      (error) => {
        if (error.status === 401) {
          console.log('CLEARING LOCAL STORAGE - 5');
          localStorage.clear();
          this.router.navigate(['/login']);
        }
      });
  }
}
